import React from 'react';
import BeAuthProvider from '@besuites/auth/react';
import beauthBrowser from '@/lib/beauth/beauth.browser';
import beauthFlowTransport from '@/lib/beauth/beauth.flow.transport';

const DashboardAuthProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => (
    <BeAuthProvider browser={beauthBrowser} transport={beauthFlowTransport}>{children}</BeAuthProvider>
);

export default DashboardAuthProvider;
